module.exports = __webpack_public_path__ + "img/whatsapp.cbe839e2.png";